import { useFormik } from 'formik';
import { useEffect } from 'react';
import { PqrReconsideration } from '../../../../../../shared/types/modules/pqr';
import { useGetNameOrValue } from '../../../../../../shared/utils/useGetNameOrValue';

export const usePqrReconsideration = (reconsideration?: PqrReconsideration) => {
    const formik = useFormik({
        initialValues: {
            replica: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        formik.setValues({
            replica: useGetNameOrValue(reconsideration?.replica || ''),
        });
    }, [reconsideration]);

    return {
        formik,
    };
};
